import { c as _c } from "react/compiler-runtime";
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
const RatingCount = t0 => {
    const $ = _c(10);
    const { count: t1, short, className } = t0;
    const count = t1 === undefined ? 0 : t1;
    const translate = useTranslate();
    const stringCount = `${count}`;
    let t2;
    if ($[0] !== count || $[1] !== short || $[2] !== translate) {
        t2 = short ? <span itemProp="reviewCount">{count}</span> : translate("review.review_count", {
            count
        });
        $[0] = count;
        $[1] = short;
        $[2] = translate;
        $[3] = t2;
    }
    else {
        t2 = $[3];
    }
    const countContent = t2;
    const computedClassName = `font-normal text-gray-400 ${className}`;
    let t3;
    if ($[4] !== stringCount) {
        t3 = <meta itemProp="reviewCount" content={stringCount}/>;
        $[4] = stringCount;
        $[5] = t3;
    }
    else {
        t3 = $[5];
    }
    let t4;
    if ($[6] !== computedClassName || $[7] !== countContent || $[8] !== t3) {
        t4 = <span className={computedClassName}>{t3}({countContent})</span>;
        $[6] = computedClassName;
        $[7] = countContent;
        $[8] = t3;
        $[9] = t4;
    }
    else {
        t4 = $[9];
    }
    return t4;
};
export default RatingCount;
